// Note: The first file of a module here, must also register the module

import "./home-page.component";
